import ConnectionError from '../ConnectionError/ConnectionError';
import { getTranslatedErrorMessage } from '../../api/utils/getTranslatedErrorMessage';
import { useTranslate } from '../../hooks/context/useTranslate';
import { ASWER_ERROR } from '../../constants';

interface ApiErrorProps {
  error: Error | undefined | null;
  // Optional back navigation forwarded to ConnectionError
  onBack?: () => void;
  // Pre-translated label for the back button
  backLabel?: string;
}

const ApiError = ({ error, onBack, backLabel }: ApiErrorProps) => {
  const { t } = useTranslate();
  const errorMessage = getTranslatedErrorMessage(error, t);
  const errorTitle =
    error?.name === ASWER_ERROR
      ? t('connectionErrorAswer.title')
      : t('connectionErrorContent.title');
  return (
    <ConnectionError
      message={errorMessage}
      title={errorTitle}
      onBack={onBack}
      backLabel={backLabel}
    />
  );
};

export default ApiError;
